export default "__VITE_ASSET___tPbhvMk__"